var React = require('react');
var ReactNative = require('react-native');

var Animated = require('./wrappers/Animated')

var moment = require('moment');

var LinkingManager = require('./wrappers/LinkingManager');
var Globals = require('./Globals');
var NetworkManager = require('./NetworkManager');

var Icon = require('./wrappers/ReUpIcon');

var ModelConstants = require('./constants/ModelConstants.js');
var ReUpScrollView = require('./ReUpScrollView.js');
var ReUpIconButton = require('./ReUpIconButton.js');
var ReUpField = require('./ReUpField.js');
var ShadowView = require('./ShadowView.js');
var ReUpText = require('./ReUpText');
var ReUpButton = require('./ReUpButton');
var DatePicker = require('./wrappers/react-native-datepicker-wrapper');

var MK = require('./wrappers/react-native-material-kit-wrapper');

var {
  MKColor,
  MKCardStyles,
  MKTextField,
  MKButton,
  MKSpinner,
  MKProgress,
  MKRadioButton
} = MK;

var {
  View,
  StyleSheet,
  ScrollView
} = ReactNative;

function dateKeyForDate(date)
{
  var mm = date.getMonth() + 1; // getMonth() is zero-based
  var dd = date.getDate();
  var dateString = [date.getFullYear(), "-", mm <= 9 ? '0' : '', mm, "-", dd <= 9 ? '0' : '', dd].join('');

  return dateString;
}

var Booking = require("create-react-class")(
{
  getDefaultProps : function()
  {
    return {
      timeStartMinutes:9*60,
      timeEndMinutes:17*60,
    }
  },

  getInitialState : function()
  {
    return {
      layout:{x:0, y:0, width:0, height:0},
      bookingEvents:[],
      bookingPerformers:[],
      bookingTimeframe:30,
      bookingEventID:null,
      bookingPerformerID:null,
      date: new Date(),
      availabilities: [],
      cachedAvailabilities: {},
      fetchingAvailabilities: true,
    }
  },

  componentDidMount : function()
  {
    this.setDate(this.state.date)
  },

  componentWillUnmount : function()
  {
  },

  didUpdate : function(data)
  {
    if( typeof data.BookingEvents !== 'undefined' && typeof data.BookingPerformers !== 'undefined' )
    {
      var thisThing = this;
      // make sure the event still exists
      var bookingEventID = null;
      for( var i = 0; i < data.BookingEvents.length; i++ )
      {
        if( data.BookingEvents[i].id == this.state.bookingEventID )
        {
          bookingEventID = this.state.bookingEventID;
          break;
        }
      }
      if( bookingEventID == null && data.BookingEvents.length > 0 ) bookingEventID = data.BookingEvents[0].id

      // make sure the performer still exists
      var bookingPerformerID = null;
      for( var i = 0; i < data.BookingPerformers.length; i++ )
      {
        if( data.BookingPerformers[i].id == this.state.bookingPerformerID )
        {
          bookingPerformerID = this.state.bookingPerformerID;
          break;
        }
      }
      if( bookingPerformerID == null && data.BookingPerformers.length > 0 ) bookingPerformerID = data.BookingPerformers[0].id

      var timeframe = 30;
      if( typeof data.BookingTimeframe !== 'undefined' && data.BookingTimeframe.length > 0 )
      {
        timeframe = parseInt(data.BookingTimeframe[0].timeFrame);
      }
      this.setState({bookingEvents:data.BookingEvents, bookingPerformers:data.BookingPerformers, bookingEventID:bookingEventID, bookingPerformerID:bookingPerformerID, bookingTimeframe:timeframe});
      this.setDate(this.state.date);
    }
  },

  selectEvent: function()
  {
    var thisThing = this;
    var appManager = this.props.appManager;
    var locMan = this.props.appManager.getLocalizationManager();
    var primaryButtonColor = appManager.getColorForKey("ButtonPrimaryColor");
    var primaryButtonColorLight = appManager.getColorForKey("ButtonPrimaryColor", 0.2);
    var primaryButtonTitleColor = appManager.getColorForKey("ButtonPrimaryTitleColor");
    var primaryButtonBorderColor = appManager.getColorForKey("ButtonPrimaryBorderColor");
    var secondaryButtonColor = appManager.getColorForKey("ButtonSecondaryColor");
    var secondaryButtonTitleColor = appManager.getColorForKey("ButtonSecondaryTitleColor");
    var secondaryButtonBorderColor = appManager.getColorForKey("ButtonSecondaryBorderColor");
    var generalColor = 'white';//appManager.getColorForKey("GeneralColor");
    var generalTitleColor = 'black';//appManager.getColorForKey("GeneralTitleColor");

    var customAlert =
      <ScrollView bounces={true} style={{margin:0,padding:10,marginLeft:10,marginRight:10, flexDirection:'column', height:this.state.layout.height - 60}}
        keyboardShouldPersistTaps={true}
        keyboardDismissMode={"interactive"}>
        {
          thisThing.state.bookingEvents.map(function(event, index)
          {
            if( event.is_public != '1' || event.is_active != '1') return null;

            return <View key={"event" + event.id} style={{flexDirection:'column', flex:-1}} >
                    <View style={{flexDirection:'row', flex:1}}>
                      <MKButton onPress={() => { thisThing.setEvent(event) }} maskBorderRadius={0} key={"event"+index} rippleColor={primaryButtonColorLight} style={{flexDirection:'row', alignItems:'center', flex:-1}}>
                        <MKRadioButton
                           checked={event.id == thisThing.state.bookingEventID}
                           fillColor={generalTitleColor}
                           borderOnColor={generalTitleColor}
                           borderOffColor={generalTitleColor}
                           rippleColor={primaryButtonColorLight}
                          />
                        <View style={{flexDirection:'column', marginVertical:4, flex:1}}>
                          <ReUpText appManager={appManager} style={{fontWeight:'bold'}}>{event.name}</ReUpText>
                          {
                            typeof event.price !== 'undefined' ?
                              <View><ReUpText appManager={appManager} style={{}}>{locMan.localizedDollars(event.price)}</ReUpText></View>
                            : null
                          }
                          {
                            typeof event.duration !== 'undefined' && event.hide_duration == '0' ?
                              <View><ReUpText appManager={appManager} style={{}}>{event.duration + " minutes"}</ReUpText></View>
                            : null
                          }
                          {
                            typeof event.description !== 'undefined' && event.description != null ?
                              <View style={{width:200}}><ReUpText appManager={appManager} style={{fontStyle:'italic'}}>{event.description}</ReUpText></View>
                            : null
                          }
                        </View>
                      </MKButton>
                    </View>
                    {
                      index < (thisThing.state.bookingEvents.length-1) ?
                        <ShadowView layout={thisThing.state.layout} appManager={appManager}/>
                      : null
                    }
                  </View>
          })
        }
      </ScrollView>;
    this.props.appActions.setCustomAlertShown(true,customAlert, function()
    {
    });
  },

  selectPerformer: function()
  {
    var thisThing = this;
    var appManager = this.props.appManager;
    var locMan = this.props.appManager.getLocalizationManager();
    var primaryButtonColor = appManager.getColorForKey("ButtonPrimaryColor");
    var primaryButtonColorLight = appManager.getColorForKey("ButtonPrimaryColor", 0.2);
    var primaryButtonTitleColor = appManager.getColorForKey("ButtonPrimaryTitleColor");
    var primaryButtonBorderColor = appManager.getColorForKey("ButtonPrimaryBorderColor");
    var secondaryButtonColor = appManager.getColorForKey("ButtonSecondaryColor");
    var secondaryButtonTitleColor = appManager.getColorForKey("ButtonSecondaryTitleColor");
    var secondaryButtonBorderColor = appManager.getColorForKey("ButtonSecondaryBorderColor");
    var generalColor = 'white';//appManager.getColorForKey("GeneralColor");
    var generalTitleColor = 'black';//appManager.getColorForKey("GeneralTitleColor");

    var customAlert =
      <ScrollView bounces={true} style={{margin:0,padding:10,marginLeft:10,marginRight:10, flexDirection:'column', height:this.state.layout.height - 60}}
        keyboardShouldPersistTaps={true}
        keyboardDismissMode={"interactive"}>
        {
          thisThing.state.bookingPerformers.map(function(performer, index)
          {
            return <View key={"performer"+performer.id} style={{flexDirection:'column', flex:1}}  >
                    <View style={{flexDirection:'row', flex:1}}>
                      <MKButton onPress={() => { thisThing.setPerformer(performer) }} maskBorderRadius={0} key={"performer"+index} rippleColor={primaryButtonColorLight} style={{flexDirection:'row', alignItems:'center', flex:1}}>
                        <MKRadioButton
                           checked={performer.id == thisThing.state.bookingPerformerID}
                           fillColor={generalTitleColor}
                           borderOnColor={generalTitleColor}
                           borderOffColor={generalTitleColor}
                           rippleColor={primaryButtonColorLight}
                          />
                        <ReUpText appManager={typeof appManager === 'undefined' ? null : appManager} style={{}}>{performer.name}</ReUpText>
                      </MKButton>
                    </View>
                    {
                      index < (thisThing.state.bookingPerformers.length-1) ?
                        <ShadowView layout={thisThing.state.layout} appManager={appManager}/>
                      : null
                    }
                  </View>
          })
        }
      </ScrollView>;
    this.props.appActions.setCustomAlertShown(true,customAlert, function()
    {
    });
  },

  dayBack: function()
  {
    var yesterday = new Date(this.state.date.setTime( this.state.date.getTime() - 1 * 86400000 ));
    this.setDate(yesterday)
  },

  dayForward: function()
  {
    var tomorrow = new Date(this.state.date.setTime( this.state.date.getTime() + 1 * 86400000 ));
    this.setDate(tomorrow)
  },

  selectedTime: function(time)
  {
    var thisThing = this;
    var appManager = this.props.appManager;
    var appActions = this.props.appActions;
    var locMan = appManager.getLocalizationManager();
    var user = appManager.currentUser();
    var userFullName = user[ModelConstants.FirstName] + " " + user[ModelConstants.LastName];
    var clientData = {
      name : userFullName,
      email : user[ModelConstants.UserName],
      phone : "1"
    }
    var hours = Math.floor(time / 60);
    var minutes = time % 60;
    var timeString = hours + ":" + (minutes < 10 ? "0" : "") + minutes;
    var msg = "Book " + this.bookingEvent().name + " with " + this.bookingPerformer().name + " on " + locMan.localizedDate(this.state.date) + " at " + timeString + "?";
    appActions.showLocalizedAlert("Confirmation", msg, ["NO_ALERT_BUTTON","YES_ALERT_BUTTON"], [function()
    {
      appActions.hideAlert();
    },function()
    {
      appActions.hideAlert();
      appActions.setSpinnerShown(true, "Booking...");
      NetworkManager.bookSimplyBook(appManager, thisThing.state.bookingEventID, thisThing.state.bookingPerformerID, thisThing.state.date, time, clientData,
      function(data)
      {
        appActions.setSpinnerShown(false);
        if( typeof data !== 'undefined' )
        {
          thisThing.setDate(thisThing.state.date);
          appActions.showLocalizedAlert("Success!", "You have been emailed a confirmation.", [locMan.localizedStringForKey("GOT_IT_ALERT_BUTTON")], [appActions.hideAlert]);
        }
        else
        {
          console.log("data",data)
          appActions.showLocalizedAlert("Error", "That time seems to not be available.", ["Okay"], [appActions.hideAlert]);
        }
      },
      function(data)
      {
        appActions.setSpinnerShown(false);
      },
      function()
      {
        appActions.setSpinnerShown(false);
      })
    }], function(){})
  },

  setEvent: function(bookingEvent)
  {
    this.props.appActions.setCustomAlertShown(false);
    this.state.bookingEventID = bookingEvent.id;
    this.setState({bookingEventID:bookingEvent.id});
    this.setDate();
  },

  setPerformer: function(performer)
  {
    this.props.appActions.setCustomAlertShown(false);
    this.state.bookingPerformerID = performer.id;
    this.setState({bookingPerformerID:performer.id});
    this.setDate();
  },

  setDate: function(date)
  {
    if( typeof date === 'undefined' ) date = this.state.date;
    var appManager = this.props.appManager;

    var thisThing = this;
    var dateKey = dateKeyForDate(date);
    if( typeof this.state.cachedAvailabilities[dateKey] !== 'undefined' )
    {
      this.setState({date:date, availabilities:this.state.cachedAvailabilities[dateKey], fetchingAvailabilities:false});
    }
    else
    {
      this.setState({date:date, availabilities:[], fetchingAvailabilities:true});
    }

    NetworkManager.getSimplyBookTimeIntervals( appManager, date, date, this.state.bookingEventID, this.state.bookingPerformerID,
    function(data)
    {
      var cachedAvailabilities = thisThing.state.cachedAvailabilities;
      for( var dateString in data )
      {
        cachedAvailabilities[dateString] = data[dateString];
      }
      if( JSON.stringify(typeof data[dateKey] !== 'undefined' ? data[dateKey] : []) == JSON.stringify(thisThing.state.availabilities) &&
          thisThing.state.fetchingAvailabilities == false ) return;
      thisThing.setState({availabilities:typeof data[dateKey] !== 'undefined' ? data[dateKey] : [], fetchingAvailabilities:false, cachedAvailabilities:cachedAvailabilities});
    },
    function(data)
    {
      thisThing.setState({fetchingAvailabilities:false});
    }
    ,
    function(data)
    {
      thisThing.setState({fetchingAvailabilities:false});
    });
    // refresh
  },

  bookingEvent: function()
  {
    for( var i = 0; i < this.state.bookingEvents.length; i++ )
    {
      var thisEvent = this.state.bookingEvents[i];
      if( thisEvent.id == this.state.bookingEventID )
      {
        return thisEvent;
      }
    }

    return null;
  },

  bookingPerformer: function()
  {
    for( var i = 0; i < this.state.bookingPerformers.length; i++ )
    {
      var thisPerformer = this.state.bookingPerformers[i];
      if( thisPerformer.id == this.state.bookingPerformerID )
      {
        return thisPerformer;
      }
    }

    return null;
  },

  render: function()
  {
    var instructions = this.props.featureData.instructions;

    var thisThing = this;
    var appManager = this.props.appManager;
    var locManager = this.props.appManager.getLocalizationManager();
    var user = appManager.currentUser();

    var instructionColor = appManager.getColorForKey("InstructionColor");
    var instructionTitleColor = appManager.getColorForKey("InstructionTitleColor");
    var generalColor = appManager.getColorForKey("GeneralColor");
    var generalTitleColor = appManager.getColorForKey("GeneralTitleColor");
    var generalTitleColorLight = appManager.getColorForKey("GeneralTitleColor", 0.6);
    var buttonPrimaryColor = appManager.getColorForKey("ButtonPrimaryColor");
    var profileMeterBackgroundColor = appManager.getColorForKey("SecondaryColor");
    var profileMeterColor = appManager.getColorForKey("PrimaryColor");
    var rippleColor = appManager.getColorForKey("ButtonPrimaryColor", 0.4);
    var primaryButtonColor = appManager.getColorForKey("ButtonPrimaryColor");
    var primaryButtonColorLight = appManager.getColorForKey("ButtonPrimaryColor", 0.2);
    var primaryButtonTitleColor = appManager.getColorForKey("ButtonPrimaryTitleColor");
    var primaryButtonBorderColor = appManager.getColorForKey("ButtonPrimaryBorderColor");

    var creditsLeftStatement = locManager.localizedStringForKey("CREDITS_LEFT_STATEMENT");

    var bookingEvent = this.bookingEvent();
    var bookingPerformer = this.bookingPerformer();

    var availabilities = typeof this.state.availabilities[this.state.bookingPerformerID] === 'undefined' ? [] : this.state.availabilities[this.state.bookingPerformerID];
    var amTimeSlots = [];
    var pmTimeSlots = [];

    var bookingTimeframe = this.state.bookingTimeframe;
    if( typeof bookingEvent !== 'undefined' && bookingEvent != null && typeof bookingEvent.duration !== 'undefined' )
    {
      bookingTimeframe = Math.max(bookingTimeframe, bookingEvent.duration);
    }
    for( var i = 0; i < availabilities.length; i++ )
    {
      var avail = availabilities[i];
      var fromTime = avail.from.split(":");
      var toTime = avail.to.split(":");
      var fromTimeMinutes = (parseInt(fromTime[0]) * 60) + parseInt(fromTime[1]);
      var toTimeMinutes = (parseInt(toTime[0]) * 60) + parseInt(toTime[1]);
      for( var currentTime = fromTimeMinutes; (currentTime + bookingTimeframe) <= toTimeMinutes; currentTime += bookingTimeframe )
      {
        if( currentTime < (12*60) ) amTimeSlots.push(currentTime);
        else pmTimeSlots.push(currentTime);
      }
    }

    var dateName = locManager.localizedDate(this.state.date);

    var totallyEmpty = bookingEvent == null || bookingPerformer == null;
    var emptyMessage = "No appointments available on this date.";
    if( totallyEmpty )
    {
      emptyMessage = "No appointments available.";
    }

    return(
      <View style={styles.container}>
        { this.props.extras && this.props.extras.shouldHideActionBar ? null : <View style={styles.actionBarSpacer} /> }
        <View style={[styles.backgroundView, {width:this.state.layout.width, height:this.state.layout.height, backgroundColor: generalColor}]} />
        <ReUpScrollView ref={(c) => { this._ref_ptr = c; }} shouldMinimizeEmptyMessage={!totallyEmpty} bounces={true} responder={this} isEmpty={(amTimeSlots.length <= 0 && pmTimeSlots.length <= 0) && !this.state.fetchingAvailabilities} customDependencies={[Booking.customDataDependency]} featureName={"Booking"} isEmptyPostfix={emptyMessage}>

          {
            !totallyEmpty ?
              <View>
                {
                  bookingEvent != null ?
                    <View style={{flexDirection:'column', alignItems:'center', justifyContent:'center'}}>
                      <View style={{flexDirection:'row'}}>
                        <View />
                        <ReUpText appManager={typeof appManager === 'undefined' ? null : appManager} style={{color:generalTitleColor, margin:8}}>
                          {"What would you like to book?"}
                        </ReUpText>
                        <View />
                      </View>
                      <ReUpButton appManager={appManager} isSecondary={true} style={{flex:1, marginBottom:4, width:this.state.layout.width-20, marginHorizontal:10}} text={bookingEvent.name}
                        onPress={this.selectEvent} />
                    </View>
                  : null
                }
                {
                  bookingPerformer != null ?
                    <View style={{flexDirection:'column', alignItems:'center', justifyContent:'center'}}>
                      <View style={{flexDirection:'row'}}>
                        <View />
                        <ReUpText appManager={typeof appManager === 'undefined' ? null : appManager} style={{color:generalTitleColor, margin:8}}>
                          {"Who would you like to book with?"}
                        </ReUpText>
                        <View />
                      </View>
                      <ReUpButton appManager={appManager} isSecondary={true} style={{flex:1, marginBottom:4, width:this.state.layout.width-20, marginHorizontal:10}} text={bookingPerformer.name}
                        onPress={this.selectPerformer} />
                    </View>
                  : null
                }
                <View style={{flexDirection:'column', alignItems:'center', justifyContent:'center'}}>
                  <View style={{flexDirection:'row'}}>
                    <View />
                    <ReUpText appManager={typeof appManager === 'undefined' ? null : appManager} style={{color:generalTitleColor, margin:8}}>
                      {"When would you like to book?"}
                    </ReUpText>
                    <View />
                  </View>
                  <View style={{flexDirection:'column'}}>
                    <View style={{flexDirection:'row', alignItems:'center', justifyContent:'center', width:this.state.layout.width}}>
                      <View style={{alignItems:'center', justifyContent:'center', flex:-1, marginHorizontal:4, width:30}}>
                        <ReUpIconButton key="leftButton" iconName={"angle-left"} style={{pointerEvents:'auto', paddingLeft:2, width:30,height:50}} appManager={appManager} type={6} onPress={function()
                          {
                            thisThing.dayBack();
                          }} />
                      </View>
                      <View style={{flex:1}} />
                      <DatePicker
                        style={{width: 200}}
                        date={thisThing.state.date}
                        mode="date"
                        placeholder="select date"
                        format="MMMM DD, YYYY"
                        confirmBtnText="Confirm"
                        cancelBtnText="Cancel"
                        onDateChange={(dateStr, date) => {thisThing.setDate(date)}}
                        customStyles={
                        {
                          dateInput: {
                            borderColor:'transparent',
                          },
                          dateText: {
                            color:generalTitleColor, fontSize:22, fontWeight:'bold'
                          },
                        }}
                        showIcon={false}
                      />
                      <View style={{flex:1}}/>
                      <View style={{alignItems:'center', justifyContent:'center', flex:-1, marginHorizontal:4, width:30}}>
                        <ReUpIconButton key="rightButton" iconName={"angle-right"} style={{paddingLeft:2, width:30,height:50}} appManager={appManager} type={6} onPress={function()
                          {
                            thisThing.dayForward();
                          }} />
                      </View>
                    </View>
                  </View>
                  {
                    this.state.fetchingAvailabilities ?
                      <View style={{flexDirection:'row', marginTop:20}}>
                        <View />
                        <MKSpinner style={{alignSelf : 'center',backgroundColor : 'transparent'}} strokeColor={[generalTitleColor]} />
                        <View />
                      </View>
                    :
                      amTimeSlots.length > 0 || pmTimeSlots.length > 0 ?
                        <View style={{flexDirection:'row', width:this.state.layout.width}}>
                          <View style={{flex:1}} />
                          {
                            amTimeSlots.length > 0 ?
                              <View style={{flexDirection:'column', flex:-1, alignItems:'center'}}>
                                <ReUpText appManager={typeof appManager === 'undefined' ? null : appManager} style={{color:generalTitleColor}}>
                                  {"AM"}
                                </ReUpText>
                                <View>
                                {
                                  amTimeSlots.map(function(time, index)
                                  {
                                    var hours = Math.floor(time / 60);
                                    var minutes = time % 60;
                                    var timeString = hours + ":" + (minutes < 10 ? "0" : "") + minutes;
                                    return <ReUpButton appManager={appManager} style={{width:100, marginVertical:4}} text={timeString}
                                      onPress={function(){thisThing.selectedTime(time)}} />
                                  })
                                }
                                </View>
                              </View>
                            : null
                          }
                          {
                            amTimeSlots.length > 0 && pmTimeSlots.length > 0 ?
                              <View style={{flex:1}} />
                            : null
                          }
                          {
                            pmTimeSlots.length > 0 ?
                              <View style={{flexDirection:'column', flex:-1, alignItems:'center'}}>
                                <ReUpText appManager={typeof appManager === 'undefined' ? null : appManager} style={{color:generalTitleColor}}>
                                  {"PM"}
                                </ReUpText>
                                <View style={{flex:-1}}>
                                {
                                  pmTimeSlots.map(function(time, index)
                                  {
                                    var hours = Math.floor(time / 60);
                                    var minutes = time % 60;
                                    var timeString = hours + ":" + (minutes < 10 ? "0" : "") + minutes;
                                    return <ReUpButton appManager={appManager} style={{width:100, marginVertical:4}} text={timeString}
                                      onPress={function(){thisThing.selectedTime(time)}} />
                                  })
                                }
                                </View>
                              </View>
                            : null
                          }
                          <View style={{flex:1}} />
                        </View>
                      : null
                  }

                </View>
              </View>
            : <View />
          }

        </ReUpScrollView>
      </View>
    )
  }
});

Booking.getCards = function(featureData, appActions, data)
{
  var appManager = appActions._appManager;

  var didSelect = function() {appActions.requestFeatureName("Booking")};
  var iconName = featureData.data.icon.replace("fa-", "")
  return [{
    didSelect : didSelect,
    title : featureData.data.title,
    body1 : featureData.data.tip,
    icon : iconName,
    cardType : 0,
    sortOrder : 0,
  }];
}

Booking.customDependencyKeys = ["BookingEvents", "BookingPerformers", "BookingTimeframe"];
Booking.customDataDependency = function(appManager, completion)
{
  NetworkManager.getSimplyBookEvents(appManager, function(events)
  {
    NetworkManager.getSimplyBookPerformers(appManager, function(performers)
    {
      NetworkManager.getSimplyBookTimeframe(appManager, function(timeFrame)
      {
	      console.log({BookingEvents:events, BookingPerformers:performers, BookingTimeframe:[{timeFrame:timeFrame}]})
        completion({BookingEvents:events, BookingPerformers:performers, BookingTimeframe:[{timeFrame:timeFrame}]});
      }, function(data){completion()}, function(){completion()});
    }, function(data){completion()}, function(){completion()});
  }, function(data){completion()}, function(){completion()});
}

var styles = StyleSheet.create({
  container:{
    flex: 1,
    alignItems: 'stretch',
    flexDirection: 'column',
  },
  actionBarSpacer: {
    height:Globals.ACTION_BAR_HEIGHT,
  },
  instructionContainer: {
    backgroundColor:'blue',
    flexDirection:'row',
  },
  instructionText: {
    margin:10,
  },
  backgroundView: {
    position: 'absolute',
  },
  creditCardIcon: {
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    margin:4,
    opacity:.6,
  },
})
Booking.dataDependencies = ["Users"];

module.exports = Booking;
